export function addressProvinces(value) {
  try {
    const entries = JSON.parse(value || '[]');
    return Array.isArray(entries)
      ? entries.filter(entry => Array.isArray(entry) && entry.length === 2 && entry.every(part => typeof part === 'string'))
      : [];
  } catch {
    return [];
  }
}

class LazyOafCustomerAccount extends HTMLElement {
  #controller;

  connectedCallback() {
    if (this.#controller) return;
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.addEventListener('change', event => {
      if (event.target.matches('[data-address-country]')) this.#updateCountry(event.target, false);
    }, options);
    this.addEventListener('submit', event => {
      if (event.target.matches('[data-address-delete]') && !window.confirm(event.target.dataset.confirm)) event.preventDefault();
    }, options);
    window.addEventListener('hashchange', this.#openRecovery, options);
    this.#openRecovery();
    for (const country of this.querySelectorAll('[data-address-country]')) {
      if (country.dataset.default) country.value = country.dataset.default;
      this.#updateCountry(country, true);
    }
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
  }

  #openRecovery = () => {
    if (window.location.hash !== '#recover') return;
    const recovery = this.querySelector('#recover');
    if (recovery) recovery.open = true;
  };

  #updateCountry(country, initial) {
    const province = this.querySelector('#' + country.dataset.provinceId);
    if (!province) return;
    const entries = addressProvinces(country.selectedOptions[0]?.dataset.provinces);
    province.replaceChildren(...entries.map(([value, label]) => new Option(label, value)));
    province.disabled = entries.length === 0;
    province.closest('[data-address-province]').hidden = entries.length === 0;
    if (initial && province.dataset.default) {
      const option = Array.from(province.options).find(option => option.value === province.dataset.default || option.textContent === province.dataset.default);
      if (option) option.selected = true;
    }
  }
}

if (!customElements.get('lazy-oaf-customer-account')) {
  customElements.define('lazy-oaf-customer-account', LazyOafCustomerAccount);
}
